import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { dbURL } from "./global";

function SuggestedSolutionForm(props) {
  const navigate = useNavigate();
  const [data, setData] = useState({
    solutionText: "",
    canSubmit: false,
  });
  const {
    ID,
    DocType,
    DocNumber,
    ProblemOrError,
    EmployeeInvolved,
    Description,
    DateReportedByManager,
    ApprovedSolution,
    DateDone,
    Resolved,
    Deleted,
    CreatedByUser,
  } = props.itemData;
  const itemDataDisplay = [
    <div key={1}>
      <div className="itemHeading">Nr</div> {ID}
    </div>,
    <div key={2}>
      <div className="itemHeading">Nr dokumentu</div> {DocNumber}
    </div>,
    <div key={3}>
      <div className="itemHeading">Opis sytuacji</div> {Description}
    </div>,
    <div key={4}>
    <div className="itemHeading">Pracownik</div> {EmployeeInvolved}
  </div>,
    <div key={4}>
    <div className="itemHeading">Data zgłoszenia</div> {DateReportedByManager}
  </div>
  ];

  const { solutionText, canSubmit } = data;

  async function loadPeople() {
    const peopleData = await fetch(dbURL + "loadPeople.php", {
      method: "GET",
      mode: "cors",
      credentials: "include",
    });
    const people = await peopleData.json();
    const peopleJSX = people.map((person, index) => {
      return (
        <option value={person.Name} key={index}>
          {person.Name}
        </option>
      );
    });
    setData({
      ...data,
      People: [people],
      peopleJSX: peopleJSX,
    });
  }

  useEffect(() => {
    loadPeople();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    //addRow();
  }
  /*
  async function addRow() {
    await fetch(dbURL + "addRow.php", {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "include",
    });

    props.setUpdate(props.update + 1);
    props.modalElement.current.innerHTML = "<div class='added'>Dodano wpis</div>";
    window.setTimeout(() => {
      navigate("../");
    }, 1000);
  }
*/
  function handleChange(e) {
    e.persist();
    const canSubmitValue = solutionText.length > 6 ? true : false;
    setData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      canSubmit: canSubmitValue,
    }));
    console.log(data);
  }

  return (
    <form onSubmit={handleSubmit} className="newItem">
      <div className="itemDetails">{itemDataDisplay}</div>
      <label htmlFor="solutionText" style={{ textAlign: "center" }}>
        <p>
          Wpisz uwagi/sugestie w polu poniżej. Zostaną
          przekazane do weryfikacji.
        </p>
        <textarea
          name="solutionText"
          value={solutionText}
          onChange={handleChange}
        />
      </label>
      <div className="buttons">
        <input
          style={{ display: canSubmit ? "block" : "none" }}
          type="submit"
          value="Dodaj"
        />
        <Link to="../">Zamknij</Link>
      </div>
    </form>
  );
}
export default SuggestedSolutionForm;
